// extracted by mini-css-extract-plugin
export default {"root":"TabButton_root__gRwy-","tabButton":"TabButton_tabButton__QzWDR","tabButton--activeTab":"TabButton_tabButton--activeTab__fzsTv"};